import { FullWidthSpace, MainContentArea, PageTitle } from "melco-ui";
import { DisplayStatistics } from "../../components/reporting/statistics/DisplayStatistics";

export const Statistics: React.FC = () => {
  return (
    <MainContentArea contentPadding>
      <PageTitle>Reporting</PageTitle>
      <FullWidthSpace direction="vertical" size="small">
        <DisplayStatistics />
      </FullWidthSpace>
    </MainContentArea>
  );
};
